import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon, MinusIcon } from "@radix-ui/react-icons"

import cn from "@/v2-ui/utils/utils.cn"

const Checkbox = (
  props: React.ComponentProps<typeof CheckboxPrimitive.Root>,
) => (
  <CheckboxPrimitive.Root {...props}>
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      {props.checked === "indeterminate" ? (
        <MinusIcon className="h-full w-full" />
      ) : (
        <CheckIcon className="h-full w-full" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
)
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
